export default "__VITE_ASSET__9bd0aaf6__"